import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { verticalActionTypesEnum } from '../../../../../shared/src/enums/vertical-types.enum';
import { GridPageStripGames } from '../GridPageStripGames';
import { GridPageStripContent } from '../GridPageStripContent';
import {
    GtmEventLocation,
    GtmEventComponent,
    GtmEventClickElement
} from '../../../../../shared/src/components/google-tag-manager/enums/gtm-event-enum';
import { GtmService } from '../../../../../shared/src/services/gtm.service';
import { useCurrentVerticalData } from '../../../../../shared/src/hooks/use-current-vertical-data.hook';

export const GridPageStripGamesCategory = ({
    strip,
    typedIndex,
    categories,
    setCurrentSubcategoryId,
}) => {
    const { t } = useTranslations();
    const {
        platformGamesReady,
        areFavoritesEnabled,
    } = useSelector(state => state.app);
    const { gamesById } = useSelector(state => state.casino);
    const { favoriteGames } = useSelector(state => state.favorites);
    const gamesCategories = categories?.filter(item => Array.isArray(item?.gameIds)) || [];
    const category = typedIndex < gamesCategories.length
        && gamesCategories[typedIndex];

    const games = useMemo(() => {
        const isFavoritesCategory = areFavoritesEnabled
            && category?.action === verticalActionTypesEnum.FAVORITES_CATEGORY;

        const games = isFavoritesCategory
            ? favoriteGames
            : category?.gameIds;
        return platformGamesReady
            ? games?.filter(gameId => gamesById?.[gameId])
            : [];
    }, [category, favoriteGames, areFavoritesEnabled, platformGamesReady]);
    const totalGamesNumber = games?.length;
    const {
        pamGameVerticalID,
        currentVerticalType,
    } = useCurrentVerticalData();
    const handleActionClick = (event) => {
        let clickAction = `see all ${category.text}`;
        event.preventDefault();
        GtmService.track({
            location: GtmEventLocation.GAME_GRID,
            component: GtmEventComponent.GRID_STRIP,
            click_element: GtmEventClickElement.BUTTON,
            click_action: clickAction,
            grid_strip_type: strip.designType,
            grid_strip_source: 'games categories',
            game_vertical_id: pamGameVerticalID,
            game_vertical_type: currentVerticalType,
            game_category: category.text,
        });
        setCurrentSubcategoryId(category.id);
    };

    return category && totalGamesNumber
        ? (
            <GridPageStripContent
                headerTitle={category.text}
                headerAction={(
                    <button className="grid-page-strip__header-action-item"
                        onClick={handleActionClick}>
                        {t('seeAll')} ({totalGamesNumber})
                    </button>
                )}
            >
                <GridPageStripGames strip={strip} games={games} />
            </GridPageStripContent>
        )
        : null;
};
